import React, { ReactElement, useMemo } from 'react'
import { Controller } from 'react-hook-form'
import AsyncSelect from 'react-select/async'
import { useHistory } from 'react-router'
import { ICommuneData } from '../../interfaces/Address'
import {
  asyncDebounce,
  handleError,
  processCitiesList,
} from '../../services/utils'
import { ISearchSelect } from '../../interfaces/FormFields'
import ErrorMessage from '../Alerts/ErrorMessage'
import { searchSelectStyle } from './SearchSelectStyle'
import { getCitiesList } from '../../services/Kyc'

const AsyncSearchSelect = ({
  error,
  options,
  value,
  placeHolder = 'Sélectionner',
  label,
  id,
  name,
  control,
  rules,
  className,
  onChange,
  required,
  inputSearchExpression = /\W/g,
  postalCode,
}: ISearchSelect): ReactElement => {
  const history = useHistory()
  const debouncedChangeHandler = useMemo(() => {
    return asyncDebounce(
      (inputValue: string, postalCodeValue: string) =>
        getCitiesList(inputValue, postalCodeValue),
      1000
    )
  }, [])

  const handleInputChange = (newValue: string) => {
    return newValue.replace(inputSearchExpression, ' ')
  }

  const loadOptions = (inputValue: string) => {
    return debouncedChangeHandler(inputValue, postalCode)
      .then((response) => processCitiesList(response as ICommuneData[]))
      .catch((e) => handleError(e, history))
  }

  return (
    <div className={className}>
      <label
        htmlFor={name}
        className={`inputLabel ${required ? 'inputLabelRequired' : ''}`}
      >
        {label}
      </label>
      <Controller
        id={id}
        name={name}
        placeholder={placeHolder}
        control={control}
        valueName={name}
        isClearable={false}
        trim={true}
        options={options}
        as={AsyncSelect}
        rules={rules}
        onChange={([selected]) => onChange(selected)}
        defaultValue={value}
        value={value}
        loadOptions={loadOptions}
        defaultOptions={options}
        onInputChange={handleInputChange}
        styles={searchSelectStyle}
      />
      {error && (
        <div className="mb1">
          <ErrorMessage errorMessage={error.message} />
        </div>
      )}
    </div>
  )
}

export default AsyncSearchSelect
